// extracted by mini-css-extract-plugin
export default {"link":"style_link__wVM3I","centerGrid":"style_centerGrid__sKd3h","img":"style_img__dxNIN","namegame":"style_namegame__2qa2Y"};